import { tracked } from '@glimmer/tracking';

import type { GeneralComponentClass } from 'webapp-types';

import InfolayerTypeViewDigestComponent from 'webapp/components/infolayer/type-view-digest';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase, { EXPIRE_OK } from 'webapp/models-custom/infolayer-item/base';
import { Type as GeneralType } from 'webapp/models-custom/infolayer-item/general';
import type Scorecard from 'webapp/models-custom/scorecard';

export interface ConstructorData extends BaseConstructorData {
	metricDigest: Scorecard | null;
}

export default class InfolayerItemViewDigest extends InfolayerItemBase {
	componentClass: GeneralComponentClass = InfolayerTypeViewDigestComponent;

	@tracked metricDigest: Scorecard | null;
	@tracked status = GeneralType.LOADING;
	@tracked statusText = '';
	isDisabling = false; // we introduced this flag, so the changes on metricDigest don't intervene with the flow of infolayers

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.metricDigest = data.metricDigest;
		this.isDisabling = !!data.metricDigest?.isActive;
	}

	override get classes(): string {
		return super.classes + ' ' + this.status;
	}

	get isLoading() {
		return this.status === GeneralType.LOADING;
	}

	get isError() {
		return this.status === GeneralType.ERROR;
	}

	get digestActiveStatusString() {
		return `${this.statusString.toLowerCase()}ed`;
	}

	get statusString(): string {
		const createStr = 'Creat',
			enableStr = 'Enabl',
			disableStr = 'Disabl';

		if (this.isDisabling) {
			return disableStr;
		} else if (!this.metricDigest) {
			return createStr;
		} else {
			return enableStr;
		}
	}

	updateDigest(updatedMetricDigest: Scorecard) {
		this.metricDigest = updatedMetricDigest;
	}

	setDone() {
		this.status = GeneralType.OK;
		this.statusText = `Weekly update ${this.statusString.toLowerCase()}ed!`;
		this.expire(EXPIRE_OK);
	}

	checkIfDuplicated(items: InfolayerItemBase[]): boolean {
		return items.some(
			(item) =>
				item instanceof InfolayerItemViewDigest &&
				item.statusText === this.statusText &&
				this.isError,
		);
	}
}
